import { TTransshipmentStepId } from '../../types';

const step = {
  path: 'avalista/dados-do-conjuge',
  next: (): TTransshipmentStepId => 'identity-document-type-page',
};

export default step;
